import { memo } from 'react';

import { Flex } from '@zillow/constellation';

import PropertyCardSimple from '../components/PropertyCardSimple';

import { StyledFlex } from './StyledComponents';

import type { PropertyProps } from '../../../model/Property';

type Props = {
  listings?: Array<PropertyProps>;
};

const PropertiesViewGrid = ({ listings = [] }: Props): JSX.Element => (
  <Flex data-testid="PropertiesViewGrid" display="flex" gap="md" flexWrap="wrap">
    {listings.map((listingModel, index) => {
      return <PropertyCardSimple key={`PropertyCardSimple-${index}`} listing={listingModel} />;
    })}

    {Array(2)
      .fill(1)
      .map((_, i) => (
        <StyledFlex key={`PropertyCardSimplePlaceHolder-${i}`} flex="1 1 30%" />
      ))}
  </Flex>
);

export default memo(PropertiesViewGrid);
